import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';


@Component({
  selector: 'app-searchbar',
  templateUrl: './searchbar.component.html',
  styleUrls: ['./searchbar.component.scss']
})
export class SearchbarComponent implements OnInit, OnChanges {

  searchForm: FormGroup;
  searchFormSub: Subscription;
  searchText: any;
  @Input() isClear: Boolean = false;

  // searchSubject : BehaviorSubject<string> = new BehaviorSubject<string>('');
  @Input('inputText') inputText: any;
  @Output('searchBarValue') searchBarValueEmitter: EventEmitter<any> = new EventEmitter();

  constructor(private formBuilder: FormBuilder) {

  }

  ngOnInit(): void {
    this.searchForm = this.formBuilder.group({
      searchText: ['', [Validators.maxLength(15)]]
    })
    // *** debouncing logic ****
    this.searchFormSub = this.searchForm.valueChanges
      .pipe(debounceTime(800))
      // .debounceTime(500)
      .subscribe(newValue => {
        this.searchText = newValue.searchText
        console.log("🚀 ~ file: searchbar.component.ts:37 ~ SearchbarComponent ~ ngOnInit ~ this.searchText:", this.searchText)
        this.emitValue(this.searchText.trim())
      });
  }
  ngOnChanges(changes: SimpleChanges): void {
    const isClearChange: SimpleChange = changes.isClear; // @Input() isClear

    if (isClearChange.previousValue !== undefined) {

      if (isClearChange.currentValue !== isClearChange.previousValue) {

        this.searchForm.patchValue({
          searchText: ''
        })
      }
    }
  }

  emitValue(event) {
    console.log("🚀 ~ file: searchbar.component.ts:56 ~ SearchbarComponent ~ emitValue ~ event:", event)
    this.searchBarValueEmitter.emit(event);
  }

  onKeyUp(event) {
    if (event.length > 2) {
      this.emitValue(event)
    }
  }


  omit_number(e) {
    var regex = new RegExp("^[a-zA-Z0-9 ]+$");
    var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (regex.test(str)) {
      return true;
    }

    e.preventDefault();
    return false;
  }

  changed(event) {
  }

  ngOnDestroy() {
  }

}
